import type { TranslationTree } from '../locale.model';

export const commonEsEs: TranslationTree = {
  app: {
    name: 'Fisital.ai',
    product: 'License Manager',
  },
  cancel: 'Cancelar',
  save: 'Guardar',
  saveChanges: 'Guardar cambios',
  saving: 'Guardando…',
  savingEllipsis: 'Guardando...',
  delete: 'Eliminar',
  deleting: 'Eliminando...',
  edit: 'Editar',
  remove: 'Eliminar',
  close: 'Cerrar',
  ok: 'OK',
  create: 'Crear',
  add: 'Añadir',
  back: 'Volver',
  retry: 'Reintentar',
  confirmDelete: 'Confirmar eliminación',
  confirmDeleteQuestion: '¿Desea realmente eliminar',
  loading: 'Cargando…',
  noResults: 'No se encontraron resultados.',
  actions: 'Acciones',
  name: 'Nombre',
  description: 'Descripción',
  status: 'Estado',
  email: 'Correo electrónico',
  phone: 'Teléfono',
  select: 'Seleccione',
  all: 'Todos',
  allFeminine: 'Todas',
  active: 'Activo',
  inactive: 'Inactivo',
  activeFeminine: 'Activa',
  inactiveFeminine: 'Inactiva',
  undefined: 'Indefinido',
  rows: 'Filas',
  page: 'Página',
  of: 'de',
  total: 'en total',
  registered: 'Registrados',
  registeredCount: '{{count}} registrado(s)',
  yes: 'SÍ',
  no: 'NO',
  filters: 'Filtros:',
  search: 'Buscar',
  exportPdf: 'Exportar PDF',
  width: 'Ancho',
  icon: 'Icono',
  type: 'Tipo',
  code: 'Código',
  region: 'Región',
  clients: 'Clientes',
  category: 'Categoría',
  section: 'Sección',
  path: 'Ruta',
  marker: 'Marcador',
  optional: 'opcional',
  noFile: 'Ningún archivo seleccionado',
  noPreview: 'Sin vista previa',
  noFileShort: 'Sin archivo',
  browse: 'Examinar',
  expandAll: 'Expandir todo',
  collapseAll: 'Contraer todo',
  selectAll: 'Marcar todas',
  deselectAll: 'Desmarcar todas',
  activateAll: 'Activar todos',
  deactivateAll: 'Desactivar todos',
  details: 'Detalles',
  preview: 'Vista previa',
  validation: 'Validación',
  theme: {
    light: 'Activar tema claro',
    dark: 'Activar tema oscuro',
  },
  installation: {
    cloud: 'Cloud',
    onpremise: 'On-premise',
    hybrid: 'Híbrido',
  },
  menuBullet: {
    bullet: 'Bullet (punto)',
    line: 'Line (línea)',
  },
  lang: {
    ptBr: 'Portugués (BR)',
    pt: 'Portugués',
    en: 'Inglés',
    es: 'Español',
  },
  pagination: {
    total: '({{total}} en total)',
    updating: 'Actualizando la lista…',
  },
  errors: {
    apiConnection: 'No fue posible conectar con la API. Verifique la URL y CORS.',
    httpStatus: 'Error {{status}}',
    invalidCompanyResponse: 'Respuesta inválida al guardar la empresa.',
    invalidProfileCreateResponse: 'Respuesta inválida al crear el perfil.',
    invalidProfileResponse: 'Respuesta inválida de perfil.',
    invalidResetPasswordResponse: 'Respuesta inválida al restablecer la contraseña.',
    invalidUserResponse: 'Respuesta inválida al crear el usuario.',
    missingNewPassword: 'La API no devolvió la nueva contraseña temporal.',
    missingTemporaryPassword: 'La API no devolvió la contraseña temporal del nuevo usuario.',
    loginFailed: 'Error al iniciar sesión. Inténtelo de nuevo.',
  },
};

export const authEsEs: TranslationTree = {
  welcome: 'Bienvenido',
  subtitle: 'Inicie sesión con sus credenciales',
  usernameLabel: 'Correo o usuario',
  usernamePlaceholder: 'su@email.com',
  passwordLabel: 'Contraseña',
  passwordPlaceholder: '••••••••',
  showPassword: 'Mostrar contraseña',
  hidePassword: 'Ocultar contraseña',
  submit: 'Entrar',
  submitting: 'Entrando…',
  configLoading: 'Cargando…',
  retryConfig: 'Reintentar',
  error: {
    fillCredentials: 'Complete usuario y contraseña.',
  },
};

export const navEsEs: TranslationTree = {
  main: 'Principal',
  companies: 'Empresas',
  manufacturers: 'Fabricantes',
  resellers: 'Revendedores',
  operators: 'Gestión de operadores',
  parameterizations: 'Parametrizaciones',
  menus: 'Menús',
  tickets: 'Centro de Tickets',
  knowledgeBase: 'Base de Conocimiento',
  ambience: 'Ambiente',
  colorPalettes: 'Paletas de colores',
  collapse: 'Contraer',
  collapseAria: 'Contraer o expandir menú',
  plansPro: 'Planes Pro',
  upgradeEnterprise: 'Actualizar a Enterprise',
  validUntil: 'Válido hasta 31 de diciembre de 2026',
  languageAria: 'Idioma: {{locale}}',
  notificationsAria: 'Notificaciones, 3 nuevas',
  accountMenuAria: 'Menú de cuenta',
  userFallback: 'Usuario',
  myProfile: 'Mi perfil',
  logout: 'Salir',
};

export const dashboardEsEs: TranslationTree = {
  title: 'Panel',
  subtitle: 'Visión general de licencias, operaciones y consumo',
  planPro: 'Plan Pro',
  upgrade: 'Actualizar',
  alerts: {
    title: 'Alertas activas',
    llmTitle: 'Tokens LLM — 90% de capacidad',
    llmBody: 'Se acerca al límite del paquete contratado.',
    conversationsTitle: 'Conversaciones — 78% de capacidad',
    conversationsBody: 'Monitoree el volumen para evitar bloqueos.',
  },
  metrics: {
    aria: 'Métricas principales',
    operators: 'Operadores',
    active: 'activos',
    activeModules: 'Módulos activos',
    available: 'disponibles',
    contractDeadline: 'Plazo del contrato',
    days: 'días',
    nextBilling: 'Próxima facturación',
    billingStatus: 'Factura · Al día',
  },
  verticals: {
    title: 'Verticales activas',
    banking: 'Banca',
    retail: 'Retail',
    industry: 'Industria',
    active: 'Activo',
  },
  resources: {
    title: 'Recursos licenciados',
    cameras: 'Cámaras',
    locations: 'Ubicaciones',
    users: 'Usuarios',
    storage: 'Almacenamiento',
  },
  userDistribution: {
    title: 'Distribución de usuarios',
    admins: 'Admin',
    operators: 'Operadores',
    viewers: 'Visualizadores',
  },
  ai: {
    title: 'IA y consumo',
    apiRequests: 'Solicitudes API',
    inferenceJobs: 'Trabajos de inferencia',
    avgStorage: 'Almacenamiento medio',
    perMonth: 'este mes',
    completed: 'completados',
    perProject: 'por proyecto',
  },
};
